module.exports = __webpack_public_path__ + "static/media/wrong.7999c924.mp3";